import {
  FilterState,
  ResearchId,
} from "../../../adapters/deep-research/state/AppState.ts";
import { useDeepResearchService } from "../../../adapters/deep-research/state/hooks/useDeepResearchService.tsx";
import { FilterChips } from "../../../feature-components/FilterChips/FilterChips.tsx";

export const ConnectedFilterChips = (props: {
  filterState: FilterState;
  researchId: ResearchId;
}) => {
  const appService = useDeepResearchService();
  return (
    <FilterChips
      filterState={props.filterState}
      onDelete={(newState) => {
        appService
          .setFilters({
            researchId: props.researchId,
            filters: newState,
          })
          .then();
      }}
    />
  );
};
